/**
 * The order a field hand's job list is read in: the job they are on, then the
 * ones coming up, then the ones waiting on someone, then everything else.
 *
 * `/my-jobs` returns this ranking itself (API #5). It is repeated here because
 * the list is also served from the offline cache, which holds whatever order
 * the rows were stored in — without this, the same screen reads in two
 * different orders depending on signal.
 *
 * Only the rank is applied. Within a rank the incoming order is kept (the sort
 * is stable), so this never reorders what the API already ordered.
 */
const FIELD_JOB_RANK: Record<string, number> = {
  active: 0,
  scheduled: 1,
  on_hold: 2,
  pending: 3,
};
const REST = 4;

export function rankFieldJobs<T extends { status?: unknown }>(jobs: readonly T[]): T[] {
  const rank = (j: T) =>
    typeof j.status === 'string' && Object.prototype.hasOwnProperty.call(FIELD_JOB_RANK, j.status)
      ? FIELD_JOB_RANK[j.status]
      : REST;
  return jobs
    .map((job, i) => ({ job, i, r: rank(job) }))
    .sort((a, b) => a.r - b.r || a.i - b.i)
    .map(e => e.job);
}
